import { useMediaQuery } from "@chakra-ui/react";

const designWidth = 1920;
const minDesignWidth = 1440;
export function percent(px: number) {
  return `${px * (100 / designWidth)}%`;
}

export function vw(px: number) {
  return `${px * (100 / designWidth)}vw`;
}

export function calcPX(px: number) {
  return `${(px / designWidth) * minDesignWidth}px`;
}

export function useResponsive() {
  const [isLargerThan1440] = useMediaQuery("(min-width: 1440px)");
  return isLargerThan1440 ? vw : calcPX;
}

export const genResponsivePx = (lg: number, mdScale = 0.75) => ({
  base: `${lg * mdScale}px`,
  lg: `${lg}px`,
});
